import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getSmsEmailTemplate = createAsyncThunk('/GetInternalNotificationTemplate', async () => {
  const response = await axiosHeadOffice.get(`/HeadOffice/GetInternalNotificationTemplate`);
  return response.data;
});

export const setSmsEmailTemplate = createAsyncThunk('/SetInternalNotificationTemplate', async (req) => {
  const response = await axiosHeadOffice.post(`/HeadOffice/SetInternalNotificationTemplate`, req);
  return response.data;
});

export const CreateNotificationTemplate = createAsyncThunk('/CreateNotificationTemplate', async (req) => {
  const response = await axiosHeadOffice.post(`/HeadOffice/CreateNotificationTemplate`, req);
  return response.data;
});

const NotificationCenterTemplateSlice = createSlice({
  name: 'NotificationCenterTemplateSlice',
  initialState: {
    loading: false,
    error: '',
    SmsEmailTemplateData: [],
    IsChecked:false
  },
  reducers: {
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },
  extraReducers: {
    [getSmsEmailTemplate.pending]: (state) => {
      state.loading = true;
    },
    [getSmsEmailTemplate.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSmsEmailTemplate.fulfilled]: (state, action) => {
      state.SmsEmailTemplateData = action.payload;
      state.loading = false;
    },
    [setSmsEmailTemplate.pending]: (state) => {
      state.loading = true;
    },
    [setSmsEmailTemplate.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setSmsEmailTemplate.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [CreateNotificationTemplate.pending]: (state) => {
      state.loading = true;
    },
    [CreateNotificationTemplate.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [CreateNotificationTemplate.fulfilled]: (state, action) => {
      state.loading = false;
    },
  }
});
export const SmsEmailTemplateActions = NotificationCenterTemplateSlice.actions;
export default NotificationCenterTemplateSlice;
